import {useParams, Navigate} from 'react-router-dom';
import ProjectCardList from '../components/ProjectCardList';
import WorkAreaList from '../components/WorkAreaList';
import './PeopleSubPage.css';
import { motion } from "framer-motion";
import Header from '../components/Header';
import PublicationCard from '../components/PublicationCard';
import AddInnerHtml from '../helpers/AddInnerHtml';
import CopyrightTooltip from '../components/CopyrightTooltip';
import Loading from '../components/Loading';

const TeamPeopleSubPage = (props) => {

    const {people, projects, workAreas, publications, loaded} = props;

    const { id } = useParams();
    const peopleLoaded = loaded?.people !== false;
    const currentMember = people.find(member => member.acf.id === id);

    if (!peopleLoaded) {
        return <Loading />;
    }

    if (!currentMember) {
        return <Navigate to="/people" replace />;
    }

    const member = currentMember.acf;

    const relatedWorkAreas = workAreas.filter(workArea => {
        return member.workAreas.some(relatedWorkArea => relatedWorkArea.id === workArea.id);
    });

    const relatedProjects = projects.filter(project => {
        return member.relatedProjects.some(relatedProject => relatedProject.id === project.id);
      });

    const relatedPublications = publications.filter(publication => {
        return member.relatedPublications.some(relatedPublication => relatedPublication.id === publication.id);
    });
        const renderPublications = relatedPublications.map(publication=>
            <PublicationCard publication={publication} key={publication.id}/>
        )

    const additionalInfo = member.additional_info;

    return(
        <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} transition={{ duration: 0.8 }}>
            <Header text={props.text}/>
            <div className="container">
                <div className='info-wrapper'>
                        <div className="peoplepeople-img-container">
                            <div className="img-tooltip-wrapper">
                                <img className="peopleImgInside" src={member.photourl.url} alt={member.name || ""}/>
                                <CopyrightTooltip copyrightText={member.photourl.caption}/>
                            </div>
                        </div>
                    <h1 className="people-subpage-title">{member.name}</h1>
                    <h3 className="member-location">{member.location}</h3>
                    <p className='subpage-description WYSIWYG'>
                    <AddInnerHtml text={member.bio}/>
                    </p>
                </div>

            <section className="sub-page-detail" style={{border:"5px solid var(--people-color)"}}>
                <div className="subpage-details-wrapper">
                    <p><b>Affiliation:</b> {member.department}</p>
                    <p><b>Position:</b> {member.position}</p>
                    <p><b>Email:</b> <a href={`mailto:${member.email}`} onClick={(event) => { event.preventDefault(); window.open(`mailto:${member.email}`)}}>{member.email}</a></p>
                    {member.link!==""&&
                    <>
                        <p className="member-link">
                            <b><a href={member.link} rel="noopener noreferrer" target="_blank" onClick={(event) => { event.preventDefault(); window.open(member.link, '_blank', 'noopener noreferrer'); }}>Link to full academic profile<span className="link-span"> ⎋ </span></a></b>
                        </p>
                    </>
                    }
                <AddInnerHtml text={additionalInfo} classNames={"additional-info"}/>
                </div>
            </section>

            {relatedWorkAreas.length>0?
                <section id="workareas" className="people-sub">
                        <h1 className="section-title sub">Related Work Areas</h1>
                        <WorkAreaList workAreas={relatedWorkAreas}/>
                </section>
                :
                null
            }

            {relatedProjects.length>0?
                <section id="projects" className="people-sub">
                    <h1 className="section-title sub">Related Projects</h1>
                    <ProjectCardList projects={relatedProjects}/>
                </section>
                :
                null
            }

            {relatedPublications.length>0?
            <section id="publications" className="people-sub" style={{height:"auto"}}>
                <div className="publications-wrapper">
                    <h1 className="section-title sub">Related Publications</h1>
                    {relatedPublications.length>0?
                    <>
                        {renderPublications}
                    </>
                    :null}
                </div>
            </section>
            :
            null}
            
            </div>
     </motion.div>
  )
}

export default TeamPeopleSubPage;